import GameState from "slotworks/model/game-state";
import FreespinRecord from "integration/revolver/schema/freespin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import BonusRecord from "integration/revolver/schema/bonus-record";
import RevolverSettings from "model/revolver-settings";

export default class FreespinsRetriggered extends Decision {
    public evaluate() {
        const record = GameState.getCurrentGame().getCurrentRecord();

        let triggered = false;

        if (record instanceof FreespinRecord && record.retrigger && !record.retriggered) {
            triggered = true;
        }

        // const retrigger = (GameState.getCurrentGame().latestRecord() as BonusRecord).retriggers;
        if(RevolverSettings.retriggerPending) {
            triggered = true;
        }

        // return triggered || (retrigger && retrigger > 0) ? Exit.True : Exit.False;
        return triggered ? Exit.True : Exit.False;
    }
}
